import { useState } from "react";
import { NO_VALUE } from "@utils/constants";
import { haveQuestionsContactText } from "@utils/siteText";
import LineItemPrice from "../line-item-price";
import { getOrderVariantTitle } from "@utils/getOrderVariantTitle";
import { ReactComponent as InfoIcon } from "@images/information-circle.svg";
import TextModal from "@components/modals/TextModal";
import VariantDisplay from "./VariantDisplay";
import { LineVariantProps, LineItemProps } from "./LineItem.model";
import * as Styled from "./LineItem.styled";

export const ItemTitle = ({ className, title, variant, isBundle, children }: LineVariantProps) => {
  const variantTitle = getOrderVariantTitle(title, variant, isBundle);

  return (
    <div className={className}>
      <strong>
        {title}
        {variantTitle ? ` - ${variantTitle}` : ""}
      </strong>
      {children}
    </div>
  );
};

const LineItem = ({ item, membershipModal, shadowPrices }: LineItemProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { discountedTotalPrice, originalTotalPrice, title, quantity, variant } = item;
  const description = variant?.product?.cartDescription?.value;
  const tags = variant?.product?.tags || [];
  const isBundle = tags.length > 0 ? tags.includes("bundle") : false;
  const isMembership = title.toLowerCase().includes("membership");

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <li>
      <Styled.Quantity>{quantity}</Styled.Quantity>
      <ItemTitle className="item-title" title={title} variant={variant} isBundle={isBundle}>
        {isMembership && (
          <>
            <Styled.LineItemInfo onClick={toggleModal}>
              <InfoIcon />
            </Styled.LineItemInfo>

            <TextModal
              toggleModal={toggleModal}
              mounted={isModalOpen}
              cmsNode={{
                title: membershipModal.title,
                portableText: membershipModal.copy,
                smallText: haveQuestionsContactText(),
              }}
            />
          </>
        )}
      </ItemTitle>
      {description && <p className={`item-desc${isBundle ? " bundle" : ""}`}>{description}</p>}
      <span className="item-price price">
        {shadowPrices ? (
          NO_VALUE
        ) : (
          <LineItemPrice
            original={originalTotalPrice.amount}
            final={discountedTotalPrice.amount}
            shadowPrices={shadowPrices}
            zeroDisplay={"FREE"}
          />
        )}
      </span>
      <VariantDisplay
        className="item-variant"
        title={title}
        variant={variant}
        isBundle={isBundle}
      />
    </li>
  );
};

export default LineItem;
